import en from './en';

const hr: typeof en = {
  home: 'početna',
  showMore: 'PRIKAŽI VIŠE',
  inProgres: {
    title: 'PROJEKT U IZGRADNJI',
    p1: 'Započela je gradnja stambeno-poslovnog objekta PROJEKT BRDA na mirnoj lokaciji istoimenog kvarta koji će biti okružen zelenilom te će se njome dolaziti lokalnom  pritupnom cestom. Idealna pozicija stanova omogućava dostupnost svim sadržajima – školi, vrtiću, tržnica, zelenim površinama, šetnicama, trgovačkim centrima, ambulanti i ostalim sadržajima koji vaš život mogu učiniti lakšim, dinamičnijim i uzbudljivijim.',
    p2: 'U izgradnji je stambeno-poslovni objekt koji će se sastojati od dvije etaže podzemnih garaža koja će biti povezana direktno sa stanovima pomoću dizala, prizemlja, 4 kata i nadgrađa sa ukupno 168 stanova. U ponudi su garsonjera, jednosobni, dvosobni i trosobni stanovi te penthouse sa predivnom krovnom terasom.',
    p3: 'Izgrađeni od visoko kvalitetnih materijala, stanovi zadovoljavaju najviše kriterije gradnje koje prati moderno i sofisticirano uređenje koje kupac sam bira kako bi svojom osobnošću stan učinio svojim novim domom.',
  },
  horizontalScroll: {
    appartments: 'STANOVA',
    garage: 'GARAŽNIH MJESTA',
    business: 'POSLOVNIH PROSTORA',
    parking: 'VANJSKIH PARKIRINH MJESTA',
  },
  apartments:{
    name:{
      studio: 'GARSONJERA',
      one: 'JEDNOSOBNI STAN',
      two: 'DVOSOBNI STAN',
      three: 'TROSOBNI STAN',
      bp: 'POSLOVNI PROSTOR',
      penthouse:'NADGRAĐE',
    }
  },
  InProgressPage: {
    errorFilter:
      'Vaša pretraga nije dala nikakve rezultate. Molimo prilagodite kriterije filtra i pokušajte ponovno.',
  },
};
export default hr;
